Vue.component("Program", {
    template: `
        <div class="burger-menu " :class="{'burger-menu--open': burgerMenuIsOpen}">
            <div class="minimized" @click="burgerMenuIsOpen=!burgerMenuIsOpen">
                <i class="txt-closed">Se program</i>
                <i class="txt-open">Luk program</i>
            </div>
            <div class="maximized">                
                <ul>
                    <li v-for="(item, i) in program" 
                        @click="toggleOpenProgramItem(i, item)" 
                        :class="{ 'burger-menu-item--open' : currentOpenProgramItem === i, 'no-content': !item.content}" :key="i">
                        <i v-if="item.content"></i>
                        <div class="time">{{item.time}}</div>
                        <div class="title" v-html="item.title"></div>
                        <div class="content" v-html="item.content"></div>
                    </li>
                </ul>
            </div>
        </div>
    `,

    data () {
        return {
            currentOpenProgramItem: -1,
            burgerMenuIsOpen: false,
            program: [
                {
                    time: "15.00",
                    title: "Velkomst",
                    content: "André Rogaczewski, formand for DI Digital og adm. direktør for Netcompany A/S"
                },
                {
                    time: "15:10",
                    title: "Margrethe Vestager: Europa ud på den anden side",
                    content: ` Margrethe Vestager, ledende næstformand samt kommissær for konkurrence og digitalisering, EU-Kommissionen med videohilsen `
                },
                {
                    time: "15:25",
                    title: "Danmark ud på den anden side",
                    content: `
                    Digitalisering som nøgle til, at Danmark kommer stærkere ud på den anden side. <br />
            
                        – Pia Ella Elmegård, Co-founder og Managing Director, Growth Tribe Denmark<br />
                        – Thomas Gyldal Petersen, borgmester i Herlev og formand for KL’s Børne- og Undervisningsudvalg<br />
                        – Jonas Buhl Gregersen, Senior VP, IT & Business Development, Tivoli A/S
 
                    `
                },
                {
                    time: "15:50",
                    title: "Startupzonen: otte startup-pitches",
                    content: ``
                },
                {
                    time: "16:00",
                    title: "Pause",
                    content: ``
                },
                {
                    time: "16:30",
                    title: "Digital læring og digitale kompetencer i en<br />post-coronatid",
                    content: `
                        – Lisbeth Knudsen, chefredaktør, Mandag Morgen og Altinget<br />
                        – Sahra-Josephine Hjorth, Co-founder og CEO CanopyLAB A/S
                    `
                },
                {
                    time: "16:50",
                    title: "Digital ledelse i en krisetid",
                    content: `
                    – Henrik Ernlund, country manager SAS Institute A/S<br />
                    – Monika Juul Henriksen, adm. direktør Visma Enterprise Denmark A/S
                    `
                },
                {
                    time: "17:10",
                    title: "Hvordan påvirker krisen vores samfund?",
                    content: `
                    Vincent Hendricks, filosof og professor, Københavns Universitet<br />
                    (NB: Oplægget kan ikke streames efterfølgende)
                    `
                },
                {
                    time: "17:30",
                    title: "Afrunding",
                    content: `
                    Christian Hannibal, branchedirektør for DI Digital (konst.)<br />
                    <strong>Herefter forfriskninger og let anretning for dem, der deltager fysisk i Industriens hus</strong>
                    `
                }

            ]
        }
    },
    methods: {
        toggleOpenProgramItem (index, item) {
            if(item.content) {
                if(this.currentOpenProgramItem == index)
                    this.currentOpenProgramItem = -1;
                else
                    this.currentOpenProgramItem = index;
            }
        }
    }
});